import Vue from 'vue'
import config from '@/config'
import store from '@/store'
import axios from 'axios'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export async function loadLanguageAsync () {
  let lang = config.app.language // 'UK'
  let brand = window.ctsautoconf.BRAND ? (window.ctsautoconf.BRAND + '/') : ''

  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }
  return axios.get('/static/translations/' + brand + lang + '.json?v=' + new Date().getTime()).then(response => {
    let msgs = response.data
    loadedLanguages.push(lang)
    i18n.setLocaleMessage(lang, msgs)
    setI18nLanguage(lang)
    store.commit('setTranslationsLoaded', true)
  }).catch(() => {
    store.commit('setTranslationsLoaded', false)
  })
}

export const localeProperties = {
  get getDefaultLocale () {
    return config.app.language.toUpperCase() === 'UK' ? 'EN' : config.app.language
  },
  get getSupportedLocales () {
    return window.ctsautoconf.AVAILABLE_LANGUAGE || [this.getDefaultLocale]
  },
  get getCurrentLocale () {
    return i18n.locale
  },
  get getUserLocale () {
    if (this.isMultiLangEnabled) {
      if (localStorage.userLocale && this.isLocaleSupported(localStorage.userLocale)) {
        return localStorage.userLocale
      }
      return this.getDefaultLocale
    }
    return config.app.language
  },
  get getInternalLocale () {
    if (this.isMultiLangEnabled) {
      return this.getUserLocale === 'EN' ? 'UK' : this.getUserLocale
    }
    return config.app.language
  },
  get isMultiLangEnabled () {
    return window.ctsautoconf.MULTI_LANGUAGE_SUPPORTED || false
  },
  set setCurrentLocale (locale) {
    i18n.locale = locale
  },
  set setUserLocale (locale) {
    localStorage.userLocale = locale
    i18n.locale = locale
  },
  isLocaleSupported (locale) {
    return this.getSupportedLocales.includes(locale)
  },
  get routerLang () {
    return this.isMultiLangEnabled ? '/:lang' : ''
  },
  get routerPathLang () {
    return this.isMultiLangEnabled ? '/' + this.getCurrentLocale.toLowerCase() : ''
  }
}

export const i18n = new VueI18n({
  locale: localeProperties.getUserLocale,
  fallbackLocale: localeProperties.getDefaultLocale,
  silentTranslationWarn: true,
  msgs: {}
})

// export default {
//   init
// }



// WEBPACK FOOTER //
// ./src/library/cdu/translations.js